<template>
	<div class="workbenchEnterpriseDetails">
		<div class="indexcenterpage">
			<leftnav class="fl"></leftnav>
			<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
				<govheader></govheader>
				<div class="index_left_centerpage">
					<!-- 上 -->
					<div class="workbench_details_top">
						<!-- 企业详情开始 -->
						<div class="enterprisedetailsbox whitebox fl">
							<div class="entitle oh">
								<h3 class="fl">{{ title }}</h3><span :class="state == 1 ? 'entitle_btn' : ''">存续</span><span
									:class="state == 2 ? 'entitle_btn' : ''">有意向</span>
							</div>
							<div class="enterprisedetails">
								<table border="0" cellspacing="0" cellpadding="0">
									<tr>
										<td><i>注册资本</i><em>{{ companyinfo.regCapital }}</em></td>
										<td><i>组织机构代码</i><em>{{ companyinfo.orgCode }}</em></td>
										<td><i>员工人数</i><em>{{ companyinfo.insurePerson }}</em></td>
									</tr>
									<tr>
										<td><i>企业类型</i><em>{{ companyinfo.type }}</em></td>
										<td><i>注册号</i><em>{{ companyinfo.regNo }}</em></td>
										<td><i>纳税人识别号</i><em>{{ companyinfo.taxNo }}</em></td>
									</tr>
									<tr>
										<td><i>行业分类</i><em>{{ companyinfo.industry }}</em></td>
										<td v-if="realController.length > 0">
											<i>疑似实际控制人</i><em>{{ realController[0].title }}</em></td>
										<td v-if="realController.length > 0">
											<i>总股权比例</i><em>{{ realController[0].proportion }}</em></td>
									</tr>
									<tr v-if="companyinfo.notionlist.length != 0">
										<td colspan="3"><i>所属概念</i><em><span v-show="i < 10"
													v-for="(item, i) in companyinfo.notionlist"
													@click="tagrouter('/enterpriseTag', 0, 'notion', item.id, item.name, 'workbench')">{{ item.name }}</span></em>
										</td>
									</tr>
									<tr>
										<td colspan="3"><i>企业画像</i><em style="width: 90%;"><span v-show="i < 18"
													v-for="(item, i) in companyinfo.taglist"
													@click="tagrouter('/enterpriseTag', 0, 'tag', item.id, item.name, 'workbench')">{{ item.name }}</span></em></em>
										</td>
									</tr>
								</table>
							</div>
						</div>
						<!-- 企业详情结束 -->
						<!-- 联系人开始 -->
						<div class="contacts whitebox fl" v-show="cnav == false">
							<div class="oh">
								<h3 class="fl">联系人</h3><span class="fr add" @click="contactframe = true">添加</span>
							</div>
							<div class="contacts_list">
								<ul class="fl contacts_list_ul">
									<!-- <li v-for="(item,i) in contactlist" @click="getcontactdetail(item.id);contactnav=i" :class="contactnav==i?'curlibg':''" >{{item.contactName}}</li> -->
									<li v-for="(item, i) in contactlist" @click="getcontactdetail(item.id); contactnav = i"
										:class="contactnav == i ? 'curlibg' : ''">{{ item.contactName }}</li>
								</ul>
								<table border="0" cellspacing="0" cellpadding="0" class="fl">
									<tr>
										<td><i>姓名</i><em>{{ contactdetails.contactName }}</em></td>
										<td><i>性别</i><em><span v-if="contactdetails.gender == 1">男</span><span
													v-if="contactdetails.gender == 2">女</span><span
													v-if="contactdetails.gender == 0">未知</span></em></td>
									</tr>
									<tr>
										<td><i>部门</i><em>{{ contactdetails.departmentId }}</em></td>
										<td><i>职位</i><em>{{ contactdetails.position }}</em></td>
									</tr>
									<tr>
										<td><i>手机</i><em>{{ contactdetails.mobile }}</em></td>
										<td><i>微信</i><em>{{ contactdetails.wechat }}</em></td>
									</tr>
									<tr>
										<td><i>QQ</i><em>{{ contactdetails.qq }}</em></td>
										<td><i>邮箱</i><em>{{ contactdetails.email }}</em></td>
									</tr>
									<tr>
										<td colspan="2"><i>备注</i><em>{{ contactdetails.remark }}</em></td>
									</tr>
								</table>
							</div>
						</div>

						<div class="contacts whitebox fl" v-show="cnav">
							<div class="oh">
								<h3 class="fl">联系人</h3><span class="fr add" @click="contactframe = true">添加</span>
							</div>
							<div class="contacts_list">
								<ul class="fl contacts_list_ul">
									<!-- <li v-for="(item,i) in contactlist" @click="getcontactdetail(item.id);contactnav=i" :class="contactnav==i?'curlibg':''" >{{item.contactName}}</li> -->
									<li v-for="(item, i) in contactlist" @click="getcontactdetail(item.id); contactnav = i"
										:class="contactnav == i ? 'curlibg' : ''">{{ item.contactName }}</li>
								</ul>
								<table border="0" cellspacing="0" cellpadding="0" class="fl">
									<tr>
										<td><i>姓名</i><em>{{ contactlist[0].contactName }}</em></td>
										<td><i>性别</i><em><span v-if="contactlist[0].gender == 1">男</span><span
													v-if="contactlist[0].gender == 2">女</span><span
													v-if="contactlist[0].gender == 0"></span></em></td>
									</tr>
									<tr>
										<td><i>部门</i><em>{{ contactlist[0].departmentId }}</em></td>
										<td><i>职位</i><em>{{ contactlist[0].position }}</em></td>
									</tr>
									<tr>
										<td><i>手机</i><em>{{ contactlist[0].mobile }}</em></td>
										<td><i>微信</i><em>{{ contactlist[0].wechat }}</em></td>
									</tr>
									<tr>
										<td><i>QQ</i><em>{{ contactlist[0].qq }}</em></td>
										<td><i>邮箱</i><em>{{ contactlist[0].email }}</em></td>
									</tr>
									<tr>
										<td colspan="2"><i>备注</i><em>{{ contactlist[0].remark }}</em></td>
									</tr>
								</table>
							</div>
						</div>
						<!-- 添加联系人弹框 -->
						<div class="framebgbox" v-show="contactframe">
							<div class="framebox">
								<div class="frame">
									<h4>添加联系人</h4>
									<div class="projectMane_labelbox_pop projectMane_labelbox_popmany">
										<div class="oh">
											<h5 class="title labelfl fl"><em class="redfont">*</em>姓 名</h5>
											<div class="labelfr fl"><el-input v-model="contactName" placeholder="请输入"
													class="inp_text"></el-input></div>
										</div>
										<div class="oh">
											<h5 class="title labelfl fl">手 机</h5>
											<div class="labelfr fl"><el-input v-model="mobile" placeholder="请输入"
													class="inp_text"></el-input></div>
										</div>
										<div class="oh">
											<h5 class="title labelfl fl">性 别</h5>
											<div class="labelfr fl"><el-select v-model="sexvalue" placeholder="请选择"
													@change=""><el-option v-for="item in sexoptions" :key="item.value"
														:label="item.label" :value="item.value"></el-option></el-select>
											</div>
										</div>
										<div class="oh">
											<h5 class="title labelfl fl">部 门</h5>
											<div class="labelfr fl"><el-select v-model="dvalue" placeholder="请选择"
													@change=""><el-option v-for="item in doptions" :key="item.value"
														:label="item.label" :value="item.value"></el-option></el-select>
											</div>
										</div>
										<div class="oh">
											<h5 class="title labelfl fl">职 位</h5>
											<div class="labelfr fl"> <el-input v-model="position" placeholder="请输入"
													class="inp_text"></el-input></div>
										</div>
										<div class="oh">
											<h5 class="title labelfl fl">微 信</h5>
											<div class="labelfr fl"><el-input v-model="weixin" placeholder="请输入"
													class="inp_text"></el-input></div>
										</div>
										<div class="oh">
											<h5 class="title labelfl fl">Q Q</h5>
											<div class="labelfr fl"><el-input v-model="qq" placeholder="请输入"
													class="inp_text"></el-input></div>
										</div>
										<div class="oh">
											<h5 class="title labelfl fl">邮 箱</h5>
											<div class="labelfr fl"><el-input v-model="email" placeholder="请输入"
													class="inp_text"></el-input></div>
										</div>
										<div class="oh remarkline">
											<h5 class="title labelfl fl">备 注</h5>
											<div class="labelfr fl"><textarea v-model="contactremark"></textarea> </div>
										</div>
										<div class="oh" v-show="erromsg.length > 0">
											<h5 class="title labelfl fl"></h5>
											<div class="labelfr fl">
												<p class="errortips redfont">{{ erromsg }}</p>
											</div>
										</div>
										<div class="oh btnbox">
											<span class="basebtn fl" @click="addcontact()">确定</span> <span
												class="graybtn fr" @click="contactframe = false">取消</span>
										</div>
									</div>
								</div>
							</div>
						</div>
						<!-- 弹框end -->
						<!-- 联系人结束 -->
					</div>
					<!-- 上 结束 -->
					<!-- 中 -->
					<div class="workbench_details_middle">
						<div class="enterprisedetailsbox whitebox fl">
							<div class="oh">
								<h3 class="fl">记录</h3>
								<span class="fr add" v-show="follow == 1" @click="gjframe = true; getParameter()">添加</span>
								<span class="fr add" v-show="follow == 2" @click="dbframe = true; getmangerlist()">添加</span>
							</div>
							<ul class="fl follow_list_ul">
								<li @click="follow = 1" :class="follow == 1 ? 'follow_curt' : ''">跟进记录</li>
								<li @click="follow = 2; gettodolist();" :class="follow == 2 ? 'follow_curt' : ''">待办记录</li>
							</ul>
							<!-- 跟进纪录表格开始 -->
							<div class="follow_list_tablebox fl">
								<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table"
									v-show="follow == 1">
									<tr>
										<th class="time">录入时间 </th>
										<th class="time">跟进时间</th>
										<th>跟进状态</th>
										<th>联系人</th>
										<th>负责人</th>
										<th>备注</th>
										<th>操作</th>
									</tr>
									<tr v-for="(item, i) in tracklist">
										<td class="time">{{ item.createTime }}</td>
										<td class="time">{{ item.contactTime }}</td>
										<td>
											<span v-show="item.trackStatus == 0">待跟进</span>
											<span v-if="item.trackStatus == 1">初访</span>
											<span v-if="item.trackStatus == 2">有意向</span>
											<span v-if="item.trackStatus == 3">已签约</span>
											<span v-if="item.trackStatus == 4">已落地</span>
											<span v-if="item.trackStatus == 5">暂时搁置</span>
										</td>
										<td>{{ item.contactName }}</td>
										<td>{{ item.managerName }}</td>
										<td>
											<span v-if="item.remark != ''">{{ item.remark }}</span>
											<span v-if="item.remark == ''">暂无</span>
										</td>
										<td class="follow_edit"><span
												@click="editgjframe = true; trackid = item.id; getParameter()">修改</span> | <span
												@click="trackid = item.id; open2()">删除</span></td>
									</tr>
								</table>
								<!-- 添加跟进纪录弹框 -->
								<div class="framebgbox" v-show="gjframe">
									<div class="framebox">
										<div class="frame">
											<h4>添加跟进记录</h4>
											<table border="0" cellspacing="0" cellpadding="0">
												<tr>
													<td>公司名称</td>
													<td>
														<span style="margin-left: 10px;">{{ companyinfo.title }}</span>
													</td>
												</tr>
												<tr>
													<td>跟进时间</td>
													<td>
														<el-date-picker v-model="trackTime" type="datetime"
															placeholder="选择日期时间" @change="dateFormat(3, trackTime)">
														</el-date-picker>
													</td>
												</tr>
												<tr>
													<td>跟进状态</td>
													<td>
														<el-select v-model="trackStatusvalue" placeholder="请选择">
															<el-option v-for="item in trackStatusoptions"
																:key="item.paraValue" :label="item.paraName"
																:value="item.paraValue">
															</el-option>
														</el-select>
													</td>
												</tr>
												<tr>
													<td>联系人</td>
													<td>
														<el-select v-model="contactId" placeholder="请选择">
															<el-option v-for="item in contactoptions" :key="item.id"
																:label="item.contactName" :value="item.id"></el-option>
														</el-select>
													</td>
												</tr>
												<tr>
													<td>备 注</td>
													<td>
														<textarea v-model="addtrackremark"></textarea>
													</td>
												</tr>
												<tr>
													<td></td>
													<td colspan="2" style="text-align: center;color: red;font-size: 14px;"
														v-show="erromsg != ''">{{ erromsg }}</td>
												</tr>
											</table>
											<div class="frame_btn">
												<span class="frame_cancel" @click="gjframe = false">取消</span>
												<span class="frame_determine" @click="addtrackfun(0, cusid)">确定</span>
											</div>
										</div>
									</div>
								</div>
								<!-- 添加跟进纪录弹框end -->
								<!-- 修改跟进纪录弹框 -->
								<div class="framebgbox" v-show="editgjframe">
									<div class="framebox">
										<div class="frame">
											<h4>添加跟进记录</h4>
											<table border="0" cellspacing="0" cellpadding="0">
												<tr>
													<td>公司名称</td>
													<td>
														<span style="margin-left: 10px;">{{ companyinfo.title }}</span>
													</td>
												</tr>
												<tr>
													<td>跟进时间</td>
													<td>
														<el-date-picker v-model="trackTime" type="datetime"
															placeholder="选择日期时间" @change="dateFormat(3, trackTime)">
														</el-date-picker>
													</td>
												</tr>
												<tr>
													<td>跟进状态</td>
													<td>
														<el-select v-model="trackStatusvalue" placeholder="请选择">
															<el-option v-for="item in trackStatusoptions"
																:key="item.paraValue" :label="item.paraName"
																:value="item.paraValue">
															</el-option>
														</el-select>
													</td>
												</tr>
												<tr>
													<td>联系人</td>
													<td>
														<el-select v-model="contactId" placeholder="请选择">
															<el-option v-for="item in contactoptions" :key="item.id"
																:label="item.contactName" :value="item.id">
															</el-option>
														</el-select>
													</td>
												</tr>
												<tr>
													<td>备 注</td>
													<td>
														<textarea v-model="addtrackremark"></textarea>
													</td>
												</tr>
												<tr>
													<td></td>
													<td colspan="2" style="text-align: center;color: red;font-size: 14px;"
														v-show="erromsg != ''">{{ erromsg }}</td>
												</tr>
											</table>
											<div class="frame_btn">
												<span class="frame_cancel" @click="editgjframe = false">取消</span>
												<span class="frame_determine" @click="addtrackfun(trackid, cusid)">确定</span>
											</div>
										</div>
									</div>
								</div>
								<!-- 修改跟进纪录弹框end -->
								<!-- 跟进纪录结束 -->
								<!-- 待办纪录 -->
								<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table"
									v-show="follow == 2">
									<tr>
										<th class="time">录入时间 </th>
										<th class="time">待办时间</th>
										<th>提前提醒</th>
										<th>联系人</th>
										<th>负责人</th>
										<th>备注</th>
										<th>操作</th>
									</tr>
									<tr v-for="item in todolist">
										<td class="time">{{ item.createTime }}</td>
										<td class="time">{{ item.todoTime }}</td>
										<td>提前{{ item.notifyTime }}小时</td>
										<td>{{ item.contactName }}</td>
										<td>{{ item.managerName }}</td>
										<td>
											<span v-if="item.remark != ''">{{ item.remark }}</span>
											<span v-if="item.remark == ''">暂无</span>
										</td>
										<td class="follow_edit"><span
												@click="editdbframe = true; todoid = item.id; getmangerlist()">修改</span> |
											<span @click="todoid = item.id; open()">删除</span></td>
									</tr>
								</table>
								<!-- 添加弹框 -->
								<div class="framebgbox" v-show="dbframe">
									<div class="framebox">
										<div class="frame">
											<h4>添加待办记录</h4>
											<table border="0" cellspacing="0" cellpadding="0">
												<tr>
													<td>公司名称</td>
													<td>
														<span style="margin-left: 10px;">{{ companyinfo.title }}</span>
													</td>
												</tr>
												<tr>
													<td>待办时间</td>
													<td>
														<el-date-picker v-model="todoTime" type="datetime"
															placeholder="选择日期时间" @change="dateFormat(1, todoTime)">
														</el-date-picker>
													</td>
												</tr>
												<tr>
													<td>提醒时间</td>
													<td>
														<el-date-picker v-model="notifyTime" type="datetime"
															placeholder="选择日期时间" @change="dateFormat(2, notifyTime)">
														</el-date-picker>
													</td>
												</tr>
												<tr>
													<td>联系人</td>
													<td>
														<el-select v-model="contactId" placeholder="请选择">
															<el-option v-for="item in contactoptions" :key="item.id"
																:label="item.contactName" :value="item.id">
															</el-option>
														</el-select>
													</td>
												</tr>
												<tr>
													<td>备 注</td>
													<td>
														<textarea v-model="dbremark"></textarea>
													</td>
												</tr>
												<tr>
													<td></td>
													<td colspan="2" style="text-align: center;color: red;font-size: 14px;"
														v-show="erromsg != ''">{{ erromsg }}</td>
												</tr>
											</table>
											<div class="frame_btn">
												<span class="frame_cancel" @click="dbframe = false">取消</span>
												<span class="frame_determine" @click="addtodofun(0, cusid)">确定</span>
											</div>
										</div>
									</div>
								</div>
								<!-- 添加待办纪录弹框end -->
								<!-- 修改待办纪录弹框 -->
								<div class="framebgbox" v-show="editdbframe">
									<div class="framebox">
										<div class="frame">
											<h4>修改待办记录</h4>
											<table border="0" cellspacing="0" cellpadding="0">
												<tr>
													<td>公司名称</td>
													<td>
														<span style="margin-left: 10px;">{{ companyinfo.title }}</span>
													</td>
												</tr>
												<tr>
													<td>待办时间</td>
													<td>
														<el-date-picker v-model="todoTime" type="datetime"
															placeholder="选择日期时间" @change="dateFormat(1, todoTime)">
														</el-date-picker>
													</td>
												</tr>
												<tr>
													<td>提醒时间</td>
													<td>
														<el-date-picker v-model="notifyTime" type="datetime"
															placeholder="选择日期时间" @change="dateFormat(2, notifyTime)">
														</el-date-picker>
													</td>
												</tr>
												<tr>
													<td>联系人</td>
													<td>
														<el-select v-model="contactId" placeholder="请选择">
															<el-option v-for="item in contactoptions" :key="item.id"
																:label="item.contactName" :value="item.id">
															</el-option>
														</el-select>
													</td>
												</tr>
												<tr>
													<td>备 注</td>
													<td>
														<textarea v-model="dbremark"></textarea>
													</td>
												</tr>
												<tr>
													<td></td>
													<td colspan="2" style="text-align: center;color: red;font-size: 14px;"
														v-show="erromsg != ''">{{ erromsg }}</td>
												</tr>
											</table>
											<div class="frame_btn">
												<span class="frame_cancel" @click="editdbframe = false">取消</span>
												<span class="frame_determine" @click="addtodofun(todoid, cusid)">确定</span>
											</div>
										</div>
									</div>
								</div>
								<!-- 修改待办弹框end -->
							</div>
							<!-- 待办纪录结束 -->
						</div>
						<!-- 纪录表格结束 -->
						<!-- 最新纪录开始 -->
						<div class="contacts whitebox fl">
							<div class="oh">
								<h3 class="fl">最新记录</h3><!-- <span class="fr add">编辑</span> -->
							</div>
							<div class="contacts_list shadowbox inputtime">
								<table border="0" cellspacing="0" cellpadding="0" class="">
									<tr>
										<td><i>录入时间</i><em>{{ newestlist[0].createTime }}</em></td>
										<td><i>最后跟进时间</i><em>{{ newestlist[0].contactTime }}</em></td>
									</tr>
									<tr>
										<td colspan="2"><i>待办时间</i><em>{{ newtodoTime }}</em></td>
									</tr>
									<tr>
										<td colspan="2"><i>跟进状态</i>
											<em>
												<span
													:class="newestlist[0].trackStatus == 1 ? 'contacts_list_stauscur' : 'contacts_list_staus'">初访</span>
												<span
													:class="newestlist[0].trackStatus == 2 ? 'contacts_list_stauscur' : 'contacts_list_staus'">有意向</span>
												<span
													:class="newestlist[0].trackStatus == 3 ? 'contacts_list_stauscur' : 'contacts_list_staus'">报价</span>
												<span
													:class="newestlist[0].trackStatus == 4 ? 'contacts_list_stauscur' : 'contacts_list_staus'">成交</span>
												<span
													:class="newestlist[0].trackStatus == 5 ? 'contacts_list_stauscur' : 'contacts_list_staus'">暂时搁置</span></em>
										</td>
									</tr>
									<tr>
										<td><i>负责人</i><em>{{ newestlist[0].managerName }}</em></td>
										<td><i>客户来源</i><em>主动咨询</em></td>
									</tr>
									<tr>
										<td colspan="2"><i>备注</i><em>{{ newestlist[0].remark }}</em></td>
									</tr>
								</table>
							</div>
						</div>
						<!-- 最新记录结束 -->
					</div>
					<!-- 中 结束 -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'workbenchEnterpriseDetails',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			title: "工作台企业详情",
			newestlist: [], //最新记录
			tracklist: [], //跟进列表
			title: "",
			newestlist: [{ createTime: "", contactTime: " ", todoTime: '', trackStatus: "", managerName: "", remark: "" }],//最新纪录
			newtodoTime: '',//最新跟进时间
			todolist: [],//待办列表  
			userdata: {},
			leaderpagetype: 2,
			erromsg: '',//弹框错误提示
			state: 1, //存续状态
			follow: 1, //待办纪录还是跟进纪录表格
			enterpriseid: 0,
			contactnav: 0,
			cnav: true, //默认联系人
			cusid: 0,
			gjframe: false, //添加跟进纪录弹框是否开启
			dbframe: false,//添加待办纪录弹框是否开启
			contactframe: false, //添加联系人弹框
			editdbframe: false,//修改待办纪录弹窗
			editgjframe: false,//修改跟进纪录弹窗
			input: '',
			sexoptions: [{ value: 1, label: '男' }, { value: 2, label: '女' }],
			sexvalue: '',
			doptions: [],
			dvalue: '',
			trackStatusoptions: [{ value: '1', label: 'x' },],
			trackStatusvalue: '',
			addtrackremark: '',
			trackid: '',
			options: [{
				value: '选项1',
				label: '黄金糕'
			}, {
				value: '选项2',
				label: '双皮奶'
			}, {
				value: '选项3',
				label: '蚵仔煎'
			}, {
				value: '选项4',
				label: '龙须面'
			}, {
				value: '选项5',
				label: '北京烤鸭'
			}],
			todoTime: '',//添加待办时间
			contactoptions: [],
			contactId: "",
			manageroptins: [],
			managerId: "",
			dbremark: '',
			notifyTime: '',
			todoid: '',
			trackTime: '',
			value: '',
			value1: '',
			cusinfo: {},
			companyinfo: { notionlist: [] },
			realController: [], //实际控制人
			contactlist: [{ address: "", contactName: " ", departmentId: '', email: "", gender: "", id: 6, mobile: "", position: "", qq: "", remark: "", wechat: "" }],
			contactdetails: { contactName: '' },
			contactName: '',
			position: '',
			mobile: '',
			weixin: '',
			qq: '',
			email: '',
			contactremark: '',

		}
	},
	beforeCreate() {
		this.todolist = [{ todoTime: '' }];
	},
	created() {
		this.$nextTick(() => {
			// 禁用右键
			document.oncontextmenu = new Function("event.returnValue=false");
			// 禁用选择
			document.onselectstart = new Function("event.returnValue=false");
		});
	},
	mounted() {
		this.userdata = this.getuseriformation();
		console.log('id', this.$route.query.id)
		this.cusid = this.$route.query.id;
		// this.enterpriseid = this.$route.query.code; 
		// console.log('1111',this.enterpriseid);
		this.getcusdetail();

	},
	methods: {
		open() { //删除企业提示
			var _this = this;
			this.$confirm('此操作降删除该客户, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$message(
					this.deletetodofun(this.todoid),
					{
						type: 'success',
						message: '删除成功!',
					});
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
		},
		open2() { //删除企业提示
			var _this = this;
			this.$confirm('此操作降删除该客户, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$message(
					this.deletetrackfun(this.trackid),
					{
						type: 'success',
						message: '删除成功!',
					});
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
		},
		//客户详情
		getcusdetail() {
			this.bus.$emit('loading', true);
			var _this = this;
			console.log('客户详情id', _this.cusid);
			this.$axios.get(this.$api.crm.customer.detail() + "?id=" + _this.cusid, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				console.log("客户详情", res);
				if (res.data.success) {
					_this.cusinfo = res.data.data;
					_this.enterpriseid = res.data.data.stockCode;
					document.title = res.data.data.customerName;
					_this.title = res.data.data.customerName;
					console.log('enterpriseid', _this.enterpriseid)
					if (res.data.data.stockCode) {
						_this.getcusinfo(); //获取企业信息第一部分
						_this.getcusinfo2();//获取企业信息第二部分
					}
					_this.gettodolist(); //获取待办列表
					_this.gettracklist(); //获取跟进列表
					if (res.data.data.contactList.length > 0) {
						_this.contactlist = res.data.data.contactList;
						_this.contactoptions = _this.contactlist;
					}
					_this.getdepartmentlist();
					_this.bus.$emit('loading', false);
				}
				else {
					if (res.data.msg == '没有权限') {
						_this.$message({
							type: 'warning',
							message: res.data.msg,
						});
						this.bus.$emit('loading', false);
					}

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//获取企业基本信息第一部分
		getcusinfo() {
			// this.bus.$emit('loading', true);
			var _this = this;
			this.$axios.get(this.$api.cyl.enterprise.detail() + "?stockCode=" + _this.enterpriseid, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				console.log("企业基本信息", res);
				if (res.data.code < 1) {

					_this.companyinfo = res.data.data.baseinfo;
					_this.companyinfo.notionlist = _this.taglistfun(_this.companyinfo.notion, _this.companyinfo.notionCode);
					_this.companyinfo.taglist = _this.taglistfun(_this.companyinfo.tag, _this.companyinfo.tagCode);

					// console.log('title',_this.companyinfo.notionlist,_this.companyinfo.taglist);
					// _this.bus.$emit('loading', false);
				}
				else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//获取企业信息第二部分
		getcusinfo2() {
			this.bus.$emit('loading', true);
			var _this = this;
			this.$axios.get(this.$api.cyl.enterprise.detail2() + "?stockCode=" + _this.enterpriseid, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				console.log("企业基本信息2", res);
				if (res.data.code < 1) {
					_this.realController = res.data.data.realController || [];//实际控制人 
					// _this.bus.$emit('loading', false);
				}
				else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//联系人详情
		getcontactdetail(contactid) {
			var _this = this;
			this.$axios.get(this.$api.crm.contact.detail() + "?contactId=" + contactid, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				console.log("联系人详情", res);
				if (res.data.code < 1) {
					_this.cnav = false;
					_this.contactdetails = res.data.data;
					console.log("11", _this.contactdetails);
				}
				else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//添加联系人
		addcontact() {
			var _this = this;
			console.log(this.contactName, this.sexvalue, this.dvalue, this.position, this.mobile, this.weixin, this.qq, this.email, this.contactremark);
			// ||this.sexvalue==''||this.dvalue==''||this.position==''||this.weixin==''||this.qq==''||this.email==''
			if (this.contactName == '') {
				this.erromsg = '姓名不得为空';
				return;
			}
			var sdgs = {
				contactId: 0,
				customerId: _this.cusid,
				contactName: _this.contactName,
				// mobile:_this.mobile,
			};
			console.log('aaa', _this.mobile, _this.mobile.length)
			if (_this.mobile.length > 10) {
				sdgs.mobile = _this.mobile;
			}
			if (_this.sexvalue.length > 0) {
				sdgs.gender = _this.sexvalue;
			}
			if (_this.dvalue > 0) {
				sdgs.departmentId = _this.dvalue;
			}
			if (_this.weixin.length > 0) {
				sdgs.weixin = _this.weixin;
			}
			if (_this.position.length > 0) {
				sdgs.position = _this.position;
			}
			if (_this.qq.length > 0) {
				sdgs.qq = _this.qq;
			}
			if (_this.email.length > 0) {
				sdgs.email = _this.email;
			}
			if (_this.contactremark.length > 0) {
				sdgs.remark = _this.contactremark;
			}
			console.log(sdgs)
			$.ajax({
				type: "POST",
				url: this.$api.crm.contact.post(),
				data: sdgs,
				headers: { AuthToken: this.userdata.token },
				success: function (res) {
					console.log(res);
					if (res.success) {
						_this.contactframe = false;
						_this.getcusdetail();
					} else {
						_this.erromsg = res.msg;
					}
				}
			})
		},
		//获取部门列表
		getdepartmentlist() {
			var _this = this;
			// this.bus.$emit('loading', true);  
			this.$axios.get(this.$api.crm.department.list(), { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				console.log("部门列表", res);
				if (res.data.success) {
					var ndepartmentlist = res.data.list;
					for (var i = 0; i < ndepartmentlist.length; i++) {
						ndepartmentlist[i].label = ndepartmentlist[i].name;
						ndepartmentlist[i].value = ndepartmentlist[i].id;
					}
					_this.doptions = ndepartmentlist;
					// console.log('1111',_this.doptions);
				}
				else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//获取跟进列表
		gettracklist() {
			var _this = this;
			this.$axios.get(this.$api.crm.track.list() + "?customerId=" + _this.cusid, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				console.log("客户跟进列表", res);
				if (res.data.code < 1) {
					_this.tracklist = res.data.list;
					// _this.turndata(_this.tracklist);
					console.log('genj	', _this.tracklist);
					if (_this.tracklist.length > 0) {
						_this.newestlist = _this.tracklist;
						console.log('1123123', _this.newestlist);
					}
				}
				else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//获取待办列表
		gettodolist() {
			var _this = this;
			this.$axios.get(this.$api.crm.todo.list() + "?customerId=" + _this.cusid, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				console.log("待办列表", res);
				if (res.data.code < 1) {
					_this.todolist = res.data.list;
					// _this.getHour(res.data.list.todoTime,res.data.list.notifyTime);
					for (var i = 0; i < _this.todolist.length; i++) {
						// console.log(_this.todolist[i].todoTime,_this.todolist[i].notifyTime);
						_this.todolist[i].notifyTime = _this.getHour(_this.todolist[i].todoTime, _this.todolist[i].notifyTime);
					}

					if (_this.todolist.length > 0) {
						_this.newtodoTime = _this.todolist[0].todoTime;
					}
				}
				else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//格式化日期 （时间戳）
		dateFormat(type, date) {
			var M = date.getMonth() + 1;
			M = M < 10 ? ('0' + M) : M;
			var y = date.getFullYear();
			var d = date.getDate();
			d = d < 10 ? ('0' + d) : d;
			var h = date.getHours() >= 10 ? date.getHours() : '0' + date.getHours();
			var m = date.getMinutes() >= 10 ? date.getMinutes() : '0' + date.getMinutes();
			var s = date.getSeconds() >= 10 ? date.getSeconds() : '0' + date.getSeconds();
			var time = y + '-' + M + '-' + d + ' ' + h + ':' + m + ':' + s;
			if (type == 1) {
				this.todoTime = time;
			}
			if (type == 2) {
				this.notifyTime = time;
			}
			if (type == 3) {
				this.trackTime = time;
			}
			console.log(time);
			return time;
		},

		getHour(s1, s2) {
			// console.log(s1,s2);
			var reDate = /\d{4}-\d{1,2}-\d{1,2} /;
			s1 = new Date((reDate.test(s1) ? s1 : '2017-1-1 ' + s1).replace(/-/g, '/'));
			s2 = new Date((reDate.test(s2) ? s2 : '2017-1-1 ' + s2).replace(/-/g, '/'));
			var ms = s2.getTime() - s1.getTime();
			if (ms < 0) return 0;
			return Math.floor(ms / 1000 / 60 / 60);
		},
		//获取负责人列表 
		getmangerlist() {
			var _this = this;
			// this.bus.$emit('loading', true);  
			this.$axios.get(this.$api.crm.user.list(), { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				console.log("用户列表", res);
				if (res.data.success) {
					_this.manageroptins = res.data.list;
				}
				else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},

		//修改或添加待办列表
		addtodofun(todoId, cusid) {
			console.log(todoId, cusid);
			console.log('错误信息', this.erromsg);
			console.log(this.todoTime, this.notifyTime, this.contactId, this.managerId, this.dbremark);
			var _this = this;
			if (this.todoTime == '' || this.notifyTime == '') {
				this.erromsg = "列表不能为空";
			}
			if (this.contactId == '') {
				this.contactId = 0;
			}
			$.ajax({
				type: "POST",
				url: this.$api.crm.todo.post(),
				data: { todoId: todoId, customerId: cusid, todoTime: _this.todoTime, notifyTime: _this.notifyTime, contactId: _this.contactId, remark: _this.dbremark, },
				headers: { AuthToken: this.userdata.token },
				success: function (res) {
					// console.log()
					console.log(res);
					if (res.success) {
						_this.dbframe = false;
						_this.editdbframe = false;
						_this.gettodolist();
					} else {
						_this.erromsg = res.msg;
					}
				}
			})
		},
		//删除待办纪录
		deletetodofun(id) {
			var _this = this;
			$.ajax({
				type: "POST",
				url: this.$api.crm.todo.delete(),
				data: { todoId: id, },
				headers: { AuthToken: this.userdata.token },
				success: function (res) {
					// console.log()
					console.log(res);
					if (res.success) {
						_this.gettodolist();
					}
				}
			})
		},
		//获取跟进状态分类
		getParameter() {
			var _this = this;
			this.$axios.get(this.$api.crm.parameter.list() + "?categoryId=1", { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				console.log("分类状态", res);
				if (res.data.success) {
					_this.trackStatusoptions = res.data.list;
				}
				else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//修改或添加跟进列表
		addtrackfun(trackId, cusid) {
			console.log(trackId, cusid)
			console.log(this.trackTime, this.trackStatusvalue, this.contactId, this.addtrackremark);
			var _this = this;
			if (this.contactId == '') {
				this.contactId = 0;
			}
			if (this.todoTime == '' || this.notifyTime == '') {
				this.erromsg = "列表不能为空";
			}
			$.ajax({
				type: "POST",
				url: this.$api.crm.track.post(),
				data: { trackId: trackId, customerId: cusid, trackTime: _this.trackTime, trackStatus: _this.trackStatusvalue, contactId: _this.contactId, remark: _this.addtrackremark, },
				headers: { AuthToken: this.userdata.token },
				success: function (res) {
					console.log(res);
					if (res.success) {
						_this.gjframe = false;
						_this.editgjframe = false;
						_this.gettracklist();
					}
				}
			})
		},
		//删除待办纪录
		deletetrackfun(id) {
			var _this = this;
			$.ajax({
				type: "POST",
				url: this.$api.crm.track.delete(),
				data: { trackId: id, },
				headers: { AuthToken: this.userdata.token },
				success: function (res) {
					console.log(res);
					if (res.success) {
						_this.gettracklist();
					} else {
						_this.$message({
							type: 'error',
							message: res.msg,
						});
						// alert(res.msg);
					}
				}
			})
		},
	}
}
</script>

<style></style>
